import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Application } from '@shopee/react-native-sdk';
import { PixelRatio, StyleSheet, Platform } from 'react-native';
export var getRealPx = function getRealPx(px) {
  return px / Math.round(PixelRatio.get());
}; // 目前仅对以下的属性进行处理转换
// const attrList = [
//   'fontSize',
//   'lineHeight',
//   'width',
//   'height',
//   'marginTop',
//   'marginBottom',
//   'marginLeft',
//   'marginRight',
//   'paddingTop',
//   'paddingRight',
//   'paddingBottom',
//   'paddingLeft',
//   'paddingVertical',
//   'paddingHorizontal',
//   'marginVertical',
//   'marginHorizontal',
// ];

export function getScaledPx(uiElementPx) {
  return uiElementPx; // const deviceWidth = Dimensions.get('screen').width;
  // let ratio = 1;
  // if (deviceWidth >= 414) {
  //   ratio = 17 / 16;
  // } else if (deviceWidth <= 320) {
  //   ratio = 14 / 16;
  // }
  // return uiElementPx * ratio;
}

export function getUnscaledPx(uiElementPx) {
  return uiElementPx; // const deviceWidth = Dimensions.get('screen').width;
  // let ratio = 1;
  // if (deviceWidth >= 414) {
  //   ratio = 17 / 16;
  // } else if (deviceWidth <= 320) {
  //   ratio = 14 / 16;
  // }
  // return uiElementPx / ratio;
}

export function CustomStyleSheet(style) {
  Object.values(style).forEach(function (styleObject) {
    Object.entries(styleObject).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        innerKey = _ref2[0],
        innerStyle = _ref2[1];

      // if (attrList.includes(innerKey) && typeof innerStyle === 'number') {
      //   (styleObject as any)[innerKey] = getScaledPx(innerStyle as number) as any;
      // }
      if (Application.appCountry === 'TH') {
        try {
          if (innerKey === 'fontSize' && typeof innerStyle === 'number') {
            var originLineHeight = styleObject.lineHeight;
            var changedLineHeight = innerStyle * 1.4;
            if (typeof originLineHeight === 'number' && originLineHeight < changedLineHeight) {
              styleObject.lineHeight = changedLineHeight;
              if (styleObject[innerKey] > 20) {
                styleObject.lineHeight = 30;
              }
            }
          }
        } catch (error) {
          console.log('TH Region lineHeight style +4 error', error);
        }
      }
    });
  });
  return StyleSheet.create(style);
} // 判断是否是 rn 环境

export var isNotWebEnvironment = Platform.OS !== 'web';